<template>
  <v-container fluid grid-list-md>
    <v-card class="mx-auto" >
        <v-toolbar color="white darken-4" >
          <v-toolbar-title>Recorrência {{subscription.id}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <!--v-btn icon>
            <v-icon>print</v-icon>
          </v-btn-->
        </v-toolbar>
      <subscription-content />
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Subscription',
  computed: {
    ...mapGetters({
      subscription: 'invoices/subscription',
    }),
  },
  created() {
    this.$store.dispatch('invoices/subscription', parseInt(this.$route.params.id));
  },
  components: {
    SubscriptionContent: () => import('@/components/desktop/invoices/subscriptions/SubscriptionContent.vue'),
  },
};
</script>
